import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { TiSocialFacebook } from 'react-icons/ti';
import { FaInstagram } from 'react-icons/fa';
import { BsYoutube } from 'react-icons/bs';
import makeInIndiaLogo from './../../Assets/Images/make-in-india-logo.webp';  
import styles from './../../Assets/CSS/Footer.module.css';
import axios from 'axios';
import { BASE_URL, BASE_FILE_URL } from './../../Environment'; 
import { toast } from 'react-toastify';
    
function Footer() {
    const current_year = new Date().getFullYear();
    const [page, setPage] = useState([]);
    const [setting, setSetting] = useState([]);
    useEffect(() => {  
        axios.get(`${BASE_URL}/page`, {
            headers: { 
                'Content-Type': 'application/json'
            }
        }).then((res) => {
            setPage(res.data.data);
        }).catch((res) => {
            toast.error(res.response.data.msg, { autoClose: 3000 });
        });    
        axios.get(`${BASE_URL}/setting`, {
            headers: { 
                'Content-Type': 'application/json'
            }
        }).then((res) => {
            setSetting(res.data.data);
        }).catch((res) => {
            toast.error(res.response.data.msg, { autoClose: 3000 }); 
        });       
    }, []);
    const [isLoading, setIsLoading] = useState(false); 
    const [email, setEmail] = useState(''); 
    const handleSubmit = async () => {
        setIsLoading(true);
        await axios.post(`${BASE_URL}/subscribe`, { email }, {
            headers: {
                'Content-Type': 'application/json' 
            } 
        }).then((res) => {
            setEmail(''); 
            toast.success(res.data.msg, { autoClose: 3000 });
            setIsLoading(false);  
        }).catch((res) => {
            toast.error(res.response.data.msg, { autoClose: 3000 });
            setIsLoading(false);
        }); 
    } 
    return (
        <footer>
            <div className={styles.spaceRow}>
                <div className={styles.footerLogoContainer}>
                    <img src={setting.logo ? BASE_FILE_URL + setting.logo : null} className={styles.footerLogo} />
                </div> 
                {/* <div className={styles.makeInIndiaContainer}>
                    <img src={makeInIndiaLogo} alt="Make in India" className={styles.makeInIndiaLogo} />
                </div>     */}
                <div> 
                    <p className={styles.subscribe}>Subscribe to Our Newsletter</p>
                    <div className={styles.inputContainer}>
                        <input type="text" value={email} className={styles.input} placeholder="Enter Email Address" onChange={e => setEmail(e.target.value)} /> 
                        <button onClick={() => handleSubmit()} className={styles.button}>{isLoading ? "Loading..." : "Subscribe"}</button> 
                    </div>  
                </div>
            </div>
            <div className={styles.ul}>
                {page?.map((data) => (
                    <Link to={'/' + data.slug} key={data.slug}>{data.name}</Link>
                ))}    
            </div>
            <div className={styles.hr}></div>
            <div className={styles.bottom}>
                <div className={styles.grayTxt}>&copy; Copyright {current_year} by {setting.name} | Design & Develop by <a href="https://www.dignexus.com" className="text-decoration-none" target="_blank">Dignexus</a></div>
                <div className={styles.icons}>   
                    <a href={setting.facebook} className={styles.iconContainer} target="_blank">
                        <TiSocialFacebook color="white" />
                    </a>
                    <a href={setting.instagram} className={styles.iconContainer} target="_blank">
                        <FaInstagram color="white" />
                    </a>
                    <a href={setting.youtube} className={styles.iconContainer} target="_blank">
                        <BsYoutube color="white" /> 
                    </a>  
                </div>
            </div>
        </footer>
    );
}

export default Footer;  